import * as React from 'react';
import { CodeImportsContextProvider, LoadDtsContextProvider, } from '../lib/code-imports-context';
import { CodeVariablesContextProvider } from '../lib/code-variables-context';
import { CodeblocksContext } from '../lib/codeblocks-context';
import { ComponentMetaContext } from '../lib/component-props-context';
export const ComponentDataProvider = (props) => {
    const { content: { imports, codeblocks, Component, loadDts }, metadata, } = props;
    const codeVariables = React.useMemo(() => {
        if (metadata.displayName && Component) {
            return {
                [metadata.displayName]: Component,
            };
        }
        return {};
    }, [metadata, Component]);
    return (React.createElement(CodeImportsContextProvider, { value: imports },
        React.createElement(LoadDtsContextProvider, { value: loadDts },
            React.createElement(ComponentMetaContext.Provider, { value: metadata },
                React.createElement(CodeVariablesContextProvider, { value: codeVariables },
                    React.createElement(CodeblocksContext.Provider, { value: codeblocks }, props.children))))));
};
//# sourceMappingURL=component-data-provider.js.map